import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { VaunceMemberInfoType } from '@kinderlabs-pos/shared-data-type';

// v2 로 들어서며 userId 가 number 타입이지만 도저히 치환할수가 없음. 그냥 string 으로 둠
export const getUserMemberAsync = (rootUrl: string) => {
	return async ({ userId }: { userId: string }) =>
		(
			await posAxiosClient.get<VaunceMemberInfoType | null>(`${rootUrl}/pos-bff/user`, {
				params: {
					userId,
				},
			})
		).data;
};
